/* eslint-disable */
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Plus, Trash2, Upload, Save, ArrowLeft, Edit, Copy, ChevronDown, ChevronRight, Sparkles, ListPlus, Tags, Edit2, Loader2 } from 'lucide-react';
import { API_URL } from '../../config';
import ImportBrandModal from './ImportBrandModal';
import AiWizardModal from './AiWizardModal';
import AiExpandModal from '../../components/AiExpandModal';
import * as XLSX from "xlsx";
import { useRef } from "react";

const ClientMediaManager = ({ projectId }) => {
  const [mediaList, setMediaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newMedia, setNewMedia] = useState({ url: '', title: '', mediaName: '', notes: '' });
  const fileInputRef = useRef(null);

  

  
  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    try {
      // setLoading(true);
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/client-media/import/${projectId}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      const data = await res.json();
      if (data.success) {
        alert(`成功导入 ${data.count} 条记录`);
        fetchMedia(); // refresh list
      } else {
        alert(data.error || '导入失败');
      }
    } catch (error) {
      alert('上传异常');
    } finally {
      // setLoading(false);
      e.target.value = null; // reset
    }
  };

  const handleDownloadTemplate = () => {
    const ws = XLSX.utils.aoa_to_sheet([
      ['文章URL(必填)', '文章标题(选填)', '媒体名称(必填)', '备注(选填)'],
      ['https://zhuanlan.zhihu.com/p/12345', '马牌轮胎评测', '知乎', '2026年Q1公关稿件']
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '自有媒体模板');
    XLSX.writeFile(wb, '自有媒体批量导入模板.xlsx');
  };

  const fetchMedia = async () => {
    try {
      // setLoading(true);
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/client-media/${projectId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setMediaList(data.data);
      }
    } catch (_E) {
      console.error(_E);
    } finally {
      // setLoading(false);
    }
  };
  
  useEffect(() => {
    if (projectId) {
      fetchMedia();
    }
  }, [projectId]);

  const handleAdd = async () => {
    if (!newMedia.url) return alert('请输入URL');
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/client-media/${projectId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(newMedia)
      });
      const data = await res.json();
      if (data.success) {
        setMediaList([data.data, ...mediaList]);
        setNewMedia({ url: '', title: '', mediaName: '', notes: '' });
      } else {
        alert(data.error || '添加失败');
      }
    } catch (_E) {
      alert('网络错误');
    }
  };

  const handleDelete = async (id) => {
    if (!confirm('确定删除吗？')) return;
    try {
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/client-media/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setMediaList(mediaList.filter(m => m.id !== id));
      }
    } catch (_E) {
      alert('删除失败');
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 p-4 rounded-lg text-sm">
        <p className="font-semibold mb-1">什么是自有媒体矩阵 (GEO 品牌防守盘)？</p>
        <p>在此处录入品牌官方网站、官方社交账号主页以及自发公关稿件的具体链接（URL）。系统在执行 AI 引擎深度抓取时，会自动识别并统计这些链接是否被 AI 直接引用或展示，以此为您计算自有资产在 AI 引擎中的“能见度”。</p>
      </div>

      
      <div className="bg-gray-50 dark:bg-slate-800 p-4 rounded-lg border border-gray-200 dark:border-slate-700">
        <div className="flex justify-between items-center mb-4">
          <h4 className="text-sm font-medium text-gray-900 dark:text-slate-100">录入新链接</h4>
          <div className="flex gap-2">
            <button onClick={handleDownloadTemplate} className="text-xs text-indigo-600 hover:text-indigo-800 dark:text-indigo-400 dark:hover:text-indigo-300">
              下载 Excel 模板
            </button>
            <input 
              type="file" 
              ref={fileInputRef} 
              className="hidden" 
              accept=".xlsx, .xls" 
              onChange={handleImport}
            />
            <button onClick={() => fileInputRef.current?.click()} className="bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-600 px-3 py-1.5 rounded-md text-xs font-medium transition-colors flex items-center gap-1 shadow-sm">
              <Upload className="w-3.5 h-3.5" /> 批量导入 Excel
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">

          <div className="col-span-2">
            <input id="clientMediaUrl" type="text" placeholder="文章URL (必填)" value={newMedia.url} onChange={e => setNewMedia({...newMedia, url: e.target.value})} className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm text-gray-900 dark:text-slate-100" />
          </div>
          <div>
            <input type="text" placeholder="媒体名称 (如: 知乎)" value={newMedia.mediaName} onChange={e => setNewMedia({...newMedia, mediaName: e.target.value})} className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm text-gray-900 dark:text-slate-100" />
          </div>
          <div>
            <button onClick={handleAdd} className="w-full bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-2">
              <Plus className="w-4 h-4" /> 添加记录
            </button>
          </div>
          <div className="col-span-2">
            <input type="text" placeholder="文章标题 (选填)" value={newMedia.title} onChange={e => setNewMedia({...newMedia, title: e.target.value})} className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm text-gray-900 dark:text-slate-100" />
          </div>
          <div className="col-span-2">
            <input type="text" placeholder="备注 (选填)" value={newMedia.notes} onChange={e => setNewMedia({...newMedia, notes: e.target.value})} className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm text-gray-900 dark:text-slate-100" />
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="text-xs text-gray-500 dark:text-slate-400 bg-gray-50 dark:bg-slate-800/50 uppercase">
            <tr>
              <th className="px-4 py-3 rounded-tl-lg">媒体名称</th>
              <th className="px-4 py-3">链接 & 标题</th>
              <th className="px-4 py-3">备注</th>
              <th className="px-4 py-3">录入时间</th>
              <th className="px-4 py-3 rounded-tr-lg w-20">操作</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="5" className="px-4 py-8 text-center text-gray-500">加载中...</td></tr>
            ) : mediaList.length === 0 ? (
              <tr><td colSpan="5" className="px-4 py-8 text-center text-gray-500 border-b border-gray-100 dark:border-slate-700">暂无自有媒体数据</td></tr>
            ) : (
              mediaList.map(item => (
                <tr key={item.id} className="border-b border-gray-100 dark:border-slate-700 hover:bg-gray-50 dark:hover:bg-slate-800/50">
                  <td className="px-4 py-3 font-medium text-gray-900 dark:text-slate-200">{item.mediaName || '-'}</td>
                  <td className="px-4 py-3">
                    <div className="flex flex-col gap-1">
                      {item.title && <span className="font-medium text-gray-800 dark:text-slate-300">{item.title}</span>}
                      <a href={item.url} target="_blank" rel="noreferrer" className="text-blue-500 hover:underline break-all">{item.url}</a>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-gray-500 dark:text-slate-400">{item.notes || '-'}</td>
                  <td className="px-4 py-3 text-gray-500 dark:text-slate-400">{new Date(item.createdAt).toLocaleDateString()}</td>
                  <td className="px-4 py-3">
                    <button onClick={() => handleDelete(item.id)} className="p-1.5 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/30 rounded">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default function BrandCompetitorConfig() {
  const navigate = useNavigate();
  const location = useLocation();
  const isPrimeContext = location.pathname.includes('brand-competitor');
  const [view, setView] = useState('list');
  const [activeTab, setActiveTab] = useState(location.pathname.includes('personas') ? 'personas' : 'basic');
  useEffect(() => {
    if (location.pathname.includes('personas') && activeTab !== 'personas') {
      setActiveTab('personas');
    } else if (!location.pathname.includes('personas') && activeTab === 'personas') {
      setActiveTab('basic');
    }
  }, [location.pathname]);
  // const [loading, setLoading] = useState(true);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isAiWizardOpen, setIsAiWizardOpen] = useState(false);

  const fileInputRef = useRef(null);

  const downloadExcelTemplate = () => {
    let data = [];
    if (keywordMode === 'simple') {
      data = [
        { "关键词": "十大口碑最好的油烟机" },
        { "关键词": "油烟机推荐" },
        { "关键词": "油烟机怎么选" }
      ];
    } else if (keywordMode === 'standard') {
      data = [
        { "核心词": "智能家居控制面板", "优化词": "智能控制面板评测\n全屋智能网关\n智能家居中控屏怎么选" }
      ];
    } else {
      data = [
        { "词包名称": "自动驾驶核心词", "核心词": "自动驾驶技术", "优化词": "自动驾驶哪个品牌强\nL2级别自动驾驶\nFSD全自动驾驶评测" }
      ];
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "模板");
    XLSX.writeFile(wb, `监控词库导入模板_${keywordMode}.xlsx`);
  };

  const handleExcelImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        
        if (data.length === 0) {
          alert('Excel文件内容为空');
          return;
        }

        if (keywordMode === 'simple') {
          const newKeywords = data.map(row => row['关键词'] || Object.values(row)[0]).filter(Boolean).join('\n');
          setKeywords(prev => prev ? prev + '\n' + newKeywords : newKeywords);
        } else if (keywordMode === 'standard') {
          const newItems = data.map(row => ({
            id: Date.now() + Math.random(),
            core: row['核心词'] || Object.values(row)[0] || '',
            expansions: row['优化词'] || Object.values(row)[1] || ''
          })).filter(i => i.core);
          
          setKeywordPackages(prev => {
            const pkgs = [...prev];
            if (pkgs.length === 0) {
              pkgs.push({ id: Date.now(), name: '默认词包', items: newItems });
            } else {
              pkgs[0].items = [...pkgs[0].items, ...newItems];
            }
            return pkgs;
          });
        } else {
          // advanced mode
          const pkgMap = {};
          data.forEach(row => {
            const pkgName = row['词包名称'] || '未命名词包';
            if (!pkgMap[pkgName]) pkgMap[pkgName] = [];
            if (row['核心词']) {
              pkgMap[pkgName].push({
                id: Date.now() + Math.random(),
                core: row['核心词'],
                expansions: row['优化词'] || ''
              });
            }
          });
          
          setKeywordPackages(prev => {
            const pkgs = [...prev];
            Object.keys(pkgMap).forEach(pkgName => {
              const existing = pkgs.find(p => p.name === pkgName);
              if (existing) {
                existing.items = [...existing.items, ...pkgMap[pkgName]];
              } else {
                pkgs.push({ id: Date.now() + Math.random(), name: pkgName, items: pkgMap[pkgName] });
              }
            });
            return pkgs;
          });
        }
      } catch (err) {
        alert('解析Excel失败，请检查文件格式');
        console.error(err);
      }
      e.target.value = ''; 
    };
    reader.readAsBinaryString(file);
  };


  const [projects, setProjects] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [colleagues, setColleagues] = useState([]);
  // const [systemPersonas, setSystemPersonas] = useState([]);
  // const [showAllSystem, setShowAllSystem] = useState(false);
  const [showSocialMedia, setShowSocialMedia] = useState(false);

  const fetchProjects = async () => {
    try {
      // setLoading(true);
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${API_URL}/brand-projects`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setProjects(data.data);
      }
    } catch (err) {
      console.error('Failed to fetch brand projects:', err);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
    
    const fetchColleagues = async () => {
      try {
        const token = localStorage.getItem('token') || '';
        const res = await fetch(`${API_URL}/colleagues`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (res.ok) {
          const data = await res.json();
          setColleagues(data);
        }
      } catch (_E) {
        console.error('Failed to fetch colleagues', e);
      }
    };
    fetchColleagues();

    const fetchUsersIfAdmin = async () => {
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      if (currentUser.role === 'ADMIN') {
        try {
          const token = localStorage.getItem('token') || '';
          const res = await fetch(`${API_URL}/admin/users`, { headers: { 'Authorization': `Bearer ${token}` } });
          if (res.ok) {
            const data = await res.json();
            setAllUsers(Array.isArray(data) ? data : (data.data || []));
          }
        } catch (_E) {
          console.error('Failed to fetch users', e);
        }
      }
    };
    fetchUsersIfAdmin();
    
    const fetchSystemPersonas = async () => {
      try {
        const token = localStorage.getItem('token') || '';
        const res = await fetch(`${API_URL}/personas/system`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          const data = await res.json();
          setSystemPersonas(data);
        }
      } catch (err) {
        console.error('Failed to fetch system personas:', err);
      }
    };
    fetchSystemPersonas();
  }, []);

  // Edit form state
  const [editingId, setEditingId] = useState(null);
  const [brand, setBrand] = useState({ name: '', aliases: '', website: '', products: '', targetUserId: '' });
  const [collaborators, setCollaborators] = useState([]);
  const [competitors, setCompetitors] = useState([]);
  const [keywordMode, setKeywordMode] = useState('advanced');
  const [keywords, setKeywords] = useState('');
  const [classifiedKeywords, setClassifiedKeywords] = useState('');
  const [keywordPackages, setKeywordPackages] = useState([]);
  const [selectedPkgId, setSelectedPkgId] = useState('all');
  const [isCategorizedExpanded, setIsCategorizedExpanded] = useState(true);
  const [isBatchEditOpen, setIsBatchEditOpen] = useState(false);
  const [expandingSynonyms, setExpandingSynonyms] = useState({});
  const [selectedItemIds, setSelectedItemIds] = useState(new Set());
  const [batchEditForm, setBatchEditForm] = useState({ stage: '', macro: '', micro: '', packageId: '', category: '' });
    const [isAdvancedEntryOpen, setIsAdvancedEntryOpen] = useState(false);
  const [aiExpandState, setAiExpandState] = useState({ isOpen: false });
  const [advancedEntryText, setAdvancedEntryText] = useState('');

  
  const [isAiTaggingLoading, setIsAiTaggingLoading] = useState(false);
  const handleAiTagging = async () => {
    if (selectedItemIds.size === 0) {
      alert('请先勾选要批量处理的关键词');
      return;
    }
    
    // Gather selected keywords
    const keywordsToTag = [];
    keywordPackages.forEach(pkg => {
      (pkg.items || []).forEach(item => {
        if (selectedItemIds.has(item.id) && item.expansions) {
          keywordsToTag.push({ id: item.id, word: item.expansions });
        }
      });
    });

    if (keywordsToTag.length === 0) return;

    try {
      setIsAiTaggingLoading(true);
      const res = await fetch(`${API_URL}/brand-projects/ai-tagging-memory`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          keywords: keywordsToTag,
          brandName: brand.name,
          themes: brand.themes || []
        })
      });

      const data = await res.json();
      if (data.success && data.data) {
        // data.data is an array or object containing array
        let tagList = Array.isArray(data.data) ? data.data : (data.data.data || data.data.result || Object.values(data.data)[0]);
        if (!Array.isArray(tagList)) {
          console.error("Unknown AI format:", data.data);
          return alert('AI 格式解析失败');
        }

        const tagMap = {};
        tagList.forEach(t => {
          tagMap[t.id] = t;
        });

        const newPkgs = keywordPackages.map(pkg => {
          return {
            ...pkg,
            items: (pkg.items || []).map(item => {
              if (item && tagMap[item.id]) {
                return {
                  ...item,
                  stage: tagMap[item.id].stage || item.stage,
                  macro: tagMap[item.id].macro || item.macro,
                  micro: tagMap[item.id].micro || item.micro,
                  volume: tagMap[item.id].volume || item.volume,
                  category: tagMap[item.id].category || item.category
                };
              }
              return item;
            })
          };
        });
        
        setKeywordPackages(newPkgs);
        setSelectedItemIds(new Set());

        // auto save inline
        const payload = {
          targetUserId: brand.targetUserId,
          name: brand.name,
          subBrandName: brand.subBrandName,
          aliases: brand.aliases,
          website: brand.website,
          logo: brand.logo,
          products: brand.products,
          themes: brand.themes,
        researchSeeds: brand.researchSeeds,
          personas: brand.personas,
          competitors: competitors,
          collaborators: collaborators,
          keywordMode,
          keywords,
          classifiedKeywords,
          alertConfig: JSON.stringify(alertConfig),
          keywordPackages: newPkgs,
          productMappingMode,
          productMappings
        };

        const token = localStorage.getItem('token') || '';
        const url = editingId ? `${API_URL}/brand-projects/${editingId}` : `${API_URL}/brand-projects`;
        const method = editingId ? 'PUT' : 'POST';

        const saveRes = await fetch(url, {
          method,
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        const saveData = await saveRes.json();
        
        if (saveData.success) {
           await fetchProjects();
           if (saveData.data) {
             handleEdit(saveData.data, true);
           }
           alert('AI 智能打标成功，且已自动保存！');
        } else {
           alert('AI 打标成功，但自动保存失败：' + (saveData.error || '未知错误'));
        }
      } else {
        alert(data.error || 'AI 打标失败');
      }
    } catch (e) {
      console.error("AI Tagging Frontend Error:", e);
      // alert('前端异常: ' + e.message); // 取消此处的报错弹窗
    } finally {
      setIsAiTaggingLoading(false);
    }
  };

  const [isAddingPkg, setIsAddingPkg] = useState(false);
  const [alertConfig, setAlertConfig] = useState({ webhook: '', rules: [{ metric: 'negative', threshold: 15 }] });
  
  const [productMappingMode, setProductMappingMode] = useState('simple'); // 'simple' | 'matrix'
  const [productMappings, setProductMappings] = useState([]); // [{id, hostProduct, competitorProducts: [{compId, compName, prodName}]}]

  const addProductMapping = () => {
    setProductMappings([...productMappings, {
      id: Date.now(),
      hostProduct: '',
      competitorProducts: competitors.map(c => ({ compId: c.id, compName: c.name, prodName: '' }))
    }]);
  };

  const removeProductMapping = (id) => {
    setProductMappings(productMappings.filter(m => m.id !== id));
  };

  const updateProductMapping = (mappingId, field, value, compId = null) => {
    setProductMappings(productMappings.map(m => {
      if (m.id === mappingId) {
        if (compId) {
          const newCompProds = [...m.competitorProducts];
          const existingIdx = newCompProds.findIndex(cp => cp.compId === compId);
          if (existingIdx >= 0) {
            newCompProds[existingIdx] = { ...newCompProds[existingIdx], [field]: value };
          } else {
            // Find comp name just in case
            const comp = competitors.find(c => c.id === compId);
            newCompProds.push({ compId, compName: comp?.name || '', prodName: field === 'prodName' ? value : '', prodAliases: field === 'prodAliases' ? value : '' });
          }
          return { ...m, competitorProducts: newCompProds };
        } else {
          return { ...m, [field]: value };
        }
      }
      return m;
    }));
  };

  // Sync competitor additions/removals into product matrix
  useEffect(() => {
    if (productMappings.length > 0) {
      setProductMappings(prev => prev.map(m => {
        const newCompProds = competitors.map(c => {
          const existing = m.competitorProducts.find(cp => cp.compId === c.id);
          return existing || { compId: c.id, compName: c.name, prodName: '' };
        });
        return { ...m, competitorProducts: newCompProds };
      }));
    }
  }, [competitors]);

  const handleCreate = () => {
    setEditingId(null);
    setBrand({ name: '', subBrandName: '', logo: '', aliases: '', website: '', products: '', targetUserId: '', socialMedia: { weibo: '', douyin: '', xhs: '', wechat: '' }, themes: [{id: 'default_theme_1', name: '', keywords: ''}], personas: [] });
    setCompetitors([]);
    setKeywordMode('advanced');
    setKeywords('');
    setClassifiedKeywords('');
    setAlertConfig({ webhook: '', rules: [{ metric: 'negative', threshold: 15 }] });
    setKeywordPackages([{ id: 'default_pkg_1', name: '未分类', items: [{ id: 'default_pkg_item_1', core: '', expansions: '' }] }]);
    setProductMappingMode('simple');
    setProductMappings([]);
    setActiveTab('basic');
    setView('edit');
  };

  const handleEdit = (project, preserveTab = false) => {
    setEditingId(project.id);
    setBrand({ 
      targetUserId: project.userId || '',
      name: project.name, 
      subBrandName: project.subBrandName || '',
      logo: project.logo || '',
      aliases: project.aliases || '', 
      website: project.website || '', 
      products: project.products || '',
      socialMedia: project.socialMedia || { weibo: '', douyin: '', xhs: '', wechat: '' },
      themes: project.themes && project.themes.length > 0 ? project.themes : [{id: 'default_theme_1', name: '', keywords: ''}],
      researchSeeds: project.promptResearchSeeds && project.promptResearchSeeds.length > 0 ? project.promptResearchSeeds : [{id: 'default_seed_1', name: '', keywords: ''}],
      personas: project.personas || []
    });
    setCollaborators(project.collaborators ? project.collaborators.map(c => c.userId) : []);
    setCompetitors(project.competitors || []);
    setKeywordMode('advanced');
    setKeywords(project.keywords || '');
    setClassifiedKeywords(project.classifiedKeywords || '');
    if (project.alertConfig) {
      try {
        setAlertConfig(JSON.parse(project.alertConfig));
      } catch (_E) {
        setAlertConfig({ webhook: '', rules: [{ metric: 'negative', threshold: 15 }] });
      }
    } else {
      setAlertConfig({ webhook: '', rules: [{ metric: 'negative', threshold: 15 }] });
    }
    
    let pkgs = project.keywordPackages || [];
    if (pkgs.length === 0) {
      pkgs = [{ id: 'default_pkg_1', name: '未分类', items: [{ id: 'default_pkg_item_1', core: '', expansions: '' }] }];
    }
    setKeywordPackages(pkgs);

    
    // Convert old comma-separated products to mapping structure if needed
    let initMappings = [];
    if (project.productMappings && project.productMappings.length > 0) {
      initMappings = project.productMappings.map(m => ({
        id: m.id,
        hostProduct: m.hostProduct,
        hostAliases: m.hostAliases || '',
        competitorProducts: (project.competitors || []).map(c => {
          const dbCp = m.competitorProducts?.find(cp => cp.competitorId === c.id);
          return {
            compId: c.id,
            compName: c.name,
            prodName: dbCp ? dbCp.prodName : '',
            prodAliases: dbCp ? dbCp.prodAliases : ''
          };
        })
      }));
    } else if (project.products) {
      initMappings = project.products.split(/\n+/).map(p => p.trim()).filter(Boolean).map(p => ({
        id: Date.now() + Math.random(),
        hostProduct: p,
        competitorProducts: project.competitors?.map(c => ({ compId: c.id, compName: c.name, prodName: '' })) || []
      }));
    }
    setProductMappings(initMappings);
    setProductMappingMode(project.productMappingMode || 'simple');
    if (!preserveTab) {
      setActiveTab('basic');
      setView('edit');
    }
  };

  const handleUploadImage = async (e, isCompetitor, compId = null) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch('/api/images/upload', {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      
      if (data.url) {
        if (!isCompetitor) {
          setBrand({...brand, logo: data.url});
        } else {
          updateCompetitor(compId, 'logo', data.url);
        }
      } else {
        alert('上传失败');
      }
    } catch (error) {
      console.error('上传图片失败', error);
      alert('上传图片报错');
    }
  };

     // keywordPackages is a dependency so it captures the new state before saving

  const handleSave = async (e, isAutoSave = false) => {
    if (!brand.name) {
      alert('请输入品牌/项目名称');
      return;
    }

    const payload = {
      targetUserId: brand.targetUserId,
      name: brand.name,
      subBrandName: brand.subBrandName,
      aliases: brand.aliases,
      website: brand.website,
      logo: brand.logo,
      products: brand.products,
      themes: brand.themes,
        researchSeeds: brand.researchSeeds,
      personas: brand.personas,
      competitors: competitors,
      collaborators: collaborators,
      keywordMode,
      keywords,
      classifiedKeywords,
      alertConfig: JSON.stringify(alertConfig),
      keywordPackages,
      productMappingMode,
      productMappings
    };

    try {
      // setLoading(true);
      const token = localStorage.getItem('token') || '';
      let url = `${API_URL}/brand-projects`;
      let method = 'POST';

      if (editingId) {
        url = `${API_URL}/brand-projects/${editingId}`;
        method = 'PUT';
      }

      const res = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (data.success) {
        await fetchProjects();
        if (data.data) {
          handleEdit(data.data, true);
        }
        if (!isAutoSave && (!e || !e.isAutoSaveEvent)) alert("保存成功！");
      } else {
        alert("保存失败：" + (data.error || "未知错误"));
      }
    } catch (err) {
      console.error(err);
      alert("保存出错");
    } finally {
      // setLoading(false);
    }
  };

  const handleDelete = async (e, id) => {
    e.stopPropagation();
    if(confirm('确定要删除这个项目配置吗？')) {
      try {
        const token = localStorage.getItem('token') || '';
        const res = await fetch(`${API_URL}/brand-projects/${id}`, {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        if (data.success) {
          fetchProjects();
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const addCompetitor = () => {
    setCompetitors([...competitors, { id: Date.now(), name: '', aliases: '', website: '', products: '' }]);
  };

  const updateCompetitor = (id, field, value) => {
    setCompetitors(competitors.map(c => c.id === id ? { ...c, [field]: value } : c));
  };

  const removeCompetitor = (id) => {
    setCompetitors(competitors.filter(c => c.id !== id));
  };

  // Keyword Package Handlers
  const addKeywordPackage = () => {
    setKeywordPackages([...keywordPackages, { id: Date.now(), name: `新词包 ${keywordPackages.length + 1}`, items: [{ id: Date.now()+1, core: '', expansions: '', category: '' }] }]);
  };

  const removeKeywordPackage = (pkgId) => {
    setKeywordPackages(keywordPackages.filter(p => p.id !== pkgId));
  };

  const addPackageItem = (pkgId) => {
    setKeywordPackages(keywordPackages.map(pkg => {
      if (pkg.id === pkgId) {
        return { ...pkg, items: [{ id: Date.now(), core: '', expansions: '', category: '' }, ...(pkg.items || [])] };
      }
      return pkg;
    }));
  };

  const removePackageItem = (pkgId, itemId) => {
    setKeywordPackages(keywordPackages.map(pkg => {
      if (pkg.id === pkgId) {
        return { ...pkg, items: pkg.items.filter(item => item.id !== itemId) };
      }
      return pkg;
    }));
  };

  const updatePackageItem = (pkgId, itemId, field, value) => {
    setKeywordPackages(keywordPackages.map(pkg => {
      if (pkg.id === pkgId) {
        return {
          ...pkg,
          items: pkg.items.map(item => item.id === itemId ? { ...item, [field]: value } : item)
        };
      }
      return pkg;
    }));
  };

  const updatePackageName = (pkgId, name) => {
    setKeywordPackages(keywordPackages.map(pkg => pkg.id === pkgId ? { ...pkg, name } : pkg));
  };

  // --- Render List View ---

  const computeTotalKeywords = (project) => {
    if (project.keywordMode === 'simple') {
      return project.keywords ? project.keywords.split(/\n+/).filter(k => k.trim()).length : 0;
    } else {
      if (project.keywordPackages && project.keywordPackages.length > 0) {
        return project.keywordPackages.reduce((total, pkg) => total + (pkg.items ? pkg.items.length : 0), 0);
      }
      return 0;
    }
  };

  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  if (view === 'list') {
    return (
      <div className="space-y-6 max-w-full p-2">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100">品牌项目管理</h1>
            <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">管理您需要监控的所有品牌、竞品及搜索词库。</p>
          </div>
          <div className="flex space-x-3">
            
            {isPrimeContext ? (
              <button onClick={() => navigate('/prime/wizard')} className="flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white px-4 py-2 rounded-lg transition-colors shadow-lg transform hover:scale-105">
                <Sparkles size={16} />
                <span>启动 PRIME 战略引擎</span>
              </button>
            ) : (
              <button onClick={() => setIsAiWizardOpen(true)} className="flex items-center space-x-2 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-4 py-2 rounded-lg transition-colors shadow-sm">
                <Sparkles size={16} />
                <span>AI 智能建项</span>
              </button>
            )}
            <button onClick={() => setIsImportModalOpen(true)} className="flex items-center space-x-2 bg-white dark:bg-slate-700 hover:bg-gray-50 dark:hover:bg-slate-600 text-gray-700 dark:text-gray-200 border border-gray-200 dark:border-slate-600 px-4 py-2 rounded-lg transition-colors shadow-sm">
              <Upload size={16} />
              <span>批量导入</span>
            </button>
            <button onClick={handleCreate} className="flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg transition-colors shadow-sm">
              <Plus size={16} />
              <span>新建监控项目</span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {projects.map((project) => (
            <div 
              key={project.id} 
              onClick={() => handleEdit(project)}
              className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 p-6 cursor-pointer hover:shadow-md hover:border-indigo-300 dark:hover:border-indigo-500/50 transition-all group"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center space-x-3">
                  {project.logo ? (
                    <img src={project.logo.startsWith('/') ? project.logo : project.logo} alt={project.name} className="w-10 h-10 rounded-full object-contain bg-white border border-gray-200 dark:border-slate-700" />
                  ) : (
                    <div className="w-10 h-10 rounded-full bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center text-indigo-600 dark:text-indigo-400 font-bold text-lg">
                      {project.name.charAt(0)}
                    </div>
                  )}
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 dark:text-slate-100 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">{project.name}{project.subBrandName ? project.subBrandName : ''}</h3>
                    <p className="text-xs text-gray-500 dark:text-slate-400">最后更新: {new Date(project.updatedAt || project.createdAt || Date.now()).toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).replace(/\//g, '-')}</p>
                  </div>
                </div>
                <button onClick={(e) => { e.stopPropagation(); handleDelete(e, project.id); }} className="text-gray-400 hover:text-red-500 p-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors opacity-0 group-hover:opacity-100">
                  <Trash2 size={16} />
                </button>
              </div>

              <div className="space-y-3">
                                {currentUser.role === 'ADMIN' && project.user && (
                  <div className="flex text-sm border-b border-gray-50 dark:border-slate-700/50 pb-2">
                    <span className="text-gray-500 dark:text-slate-400 w-20">所有者:</span>
                    <span className="text-gray-900 dark:text-slate-200 font-medium">{project.user.name}</span>
                  </div>
                )}
                <div className="flex text-sm border-b border-gray-50 dark:border-slate-700/50 pb-2">
                  <span className="text-gray-500 dark:text-slate-400 w-20">竞品数量:</span>
                  <span className="text-gray-900 dark:text-slate-200 font-medium">{project.competitors.length} 个</span>
                </div>
                <div className="flex text-sm border-b border-gray-50 dark:border-slate-700/50 pb-2">
                  <span className="text-gray-500 dark:text-slate-400 w-20">监控词库:</span>
                  <span className="text-gray-900 dark:text-slate-200 font-medium">{computeTotalKeywords(project)} 组问题</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        
      <AiWizardModal 
        isOpen={isAiWizardOpen} 
        onClose={() => setIsAiWizardOpen(false)} 
        onComplete={(newProject) => {
          setIsAiWizardOpen(false);
          // Set everything into state
          setView('edit');
          
          setEditingId(null);
          setBrand({ 
            name: newProject.brandName, 
            aliases: newProject.brandAlias, 
            website: newProject.brandWebsite, 
            logo: newProject.logo || '', 
            products: '', targetUserId: '', socialMedia: { weibo: '', douyin: '', xhs: '', wechat: '' }, 
            themes: newProject.businessThemes, 
            personas: [] 
          });
          setCompetitors((newProject.competitors || []).map(c => ({
            ...c,
            aliases: c.aliases || c.alias || ''
          })));
          if (newProject.productMappings && newProject.productMappings.length > 0) {
             setProductMappingMode('matrix');
             setProductMappings(newProject.productMappings);
          } else {
             setProductMappingMode('simple');
             setProductMappings([]);
          }
          if (Array.isArray(newProject.keywords)) {
            if (newProject.keywords.length > 0 && typeof newProject.keywords[0] === 'object') {
              setKeywordMode('advanced');
              const grouped = {};
              newProject.keywords.forEach(k => {
                const cat = k.category || '未分类';
                if (!grouped[cat]) grouped[cat] = [];
                grouped[cat].push(k.keyword || k);
              });
              const newPkgs = Object.keys(grouped).map((cat, idx) => {
                const items = grouped[cat].map((word, wIdx) => ({
                  id: `pkg_item_${Date.now()}_${idx}_${wIdx}`,
                  core: '',
                  expansions: word
                }));
                return {
                  id: `pkg_${Date.now()}_${idx}`,
                  name: cat,
                  items: items
                };
              });
              setKeywordPackages(newPkgs);
            } else {
              setKeywordMode('advanced');
              setKeywords(newProject.keywords.map(k => k.keyword || k).join('\n'));
            }
            // Still populate classified metrics for charts
            setClassifiedKeywords(JSON.stringify(newProject.keywords.map((k, i) => ({
              id: i + 1,
              word: k.keyword || k,
              stage: 'Ask',
              macro: '',
              micro: k.category || '',
              ai_heat_level: k.ai_heat_level || '低',
              real_volumes: k.real_volumes || { baidu: null, xiaohongshu: null, douyin: null }
            }))));
          } else {
            // Fallback for old string array format
            setKeywordMode('advanced');
            setKeywords(newProject.keywords);
          }

          setActiveTab('basic');
        }}
      />
      <ImportBrandModal 
        isOpen={isImportModalOpen} 
        onClose={() => setIsImportModalOpen(false)} 
        onImportSuccess={() => {
          fetchProjects();
        }}
      />

      </div>
    );
  }

  // --- Render Edit Form View ---
  
  const handleGenerateSynonyms = async (tIdx, sIdx, themeName, subThemeName) => {
    if (!subThemeName) {
      alert("请先填写二级细分指标（微观卖点）名称");
      return;
    }
    
    setExpandingSynonyms(prev => ({...prev, [`${tIdx}-${sIdx}`]: true}));
    
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/ai-expand/expand-synonyms`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          brandName: brand.name,
          themeName: themeName,
          subThemeName: subThemeName
        })
      });
      
      if (res.ok) {
        const data = await res.json();
        if (data.keywords && Array.isArray(data.keywords)) {
          const newThemes = [...(brand.themes || [])];
          const existingKeywords = newThemes[tIdx].subThemes[sIdx].keywords || '';
          const existingArr = existingKeywords.split(/\r?\n/).map(k => k.trim()).filter(Boolean);
          
          const merged = Array.from(new Set([...existingArr, ...data.keywords]));
          newThemes[tIdx].subThemes[sIdx].keywords = merged.join('\n');
          
          setBrand({...brand, themes: newThemes});
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setExpandingSynonyms(prev => ({...prev, [`${tIdx}-${sIdx}`]: false}));
    }
  };

  return (
    <div className="space-y-6 max-w-full p-2 animate-in fade-in duration-200">
      <div className="flex justify-between items-center mb-6 border-b border-gray-200 dark:border-slate-700 pb-4">
        <div className="flex items-center space-x-4">
          <button onClick={() => setView('list')} className="p-2 text-gray-500 hover:text-gray-900 dark:text-slate-400 dark:hover:text-white bg-gray-100 hover:bg-gray-200 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg transition-colors">
            <ArrowLeft size={18} />
          </button>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100">
            {editingId ? '编辑品牌项目' : '新建监控项目'}
          </h1>
        </div>
        <button id="hidden-save-btn" onClick={handleSave} style={{display: 'none'}}></button>
        <button onClick={handleSave} className="flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg transition-colors shadow-sm">
          <Save size={16} />
          <span>保存配置</span>
        </button>
      </div>

      
      {/* Tabs Navigation */}
      <div className="flex border-b border-gray-200 dark:border-slate-700 mb-6 overflow-x-auto custom-scrollbar">
        {[
          { id: 'basic', label: '基础设置 (本品&竞品)' },
          { id: 'matrix', label: '产品对标矩阵' },
          { id: 'themes', label: '核心业务维度(宏观)' },
          { id: 'researchSeeds', label: '意图与种子词(PRIME)' },
          { id: 'personas', label: '用户人设库' },
          { id: 'keywords', label: '抓取词库配置' },
          { id: 'alerts', label: '预警中心配置' },
          { id: 'clientMedia', label: '自有媒体矩阵' }
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${activeTab === tab.id ? 'border-indigo-500 text-indigo-600 dark:text-indigo-400' : 'border-transparent text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-300'}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'basic' && (

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 animate-in fade-in duration-200">
        {/* Left Column: Brand Config */}
        <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100 mb-4 border-b border-gray-100 dark:border-slate-700 pb-2">本品设置</h2>
          <div className="space-y-4 overflow-x-auto pb-4 custom-scrollbar">
            {JSON.parse(localStorage.getItem('user') || '{}').role === 'ADMIN' && (
              <div className="col-span-2 bg-indigo-50/50 dark:bg-indigo-900/10 p-3 rounded-lg border border-indigo-100 dark:border-indigo-800/30">
                <label className="block text-sm font-medium text-indigo-800 dark:text-indigo-300 mb-1">
                  归属客户 (仅超管可见)
                </label>
                <select
                  value={brand.targetUserId || ''}
                  onChange={(e) => setBrand({ ...brand, targetUserId: e.target.value })}
                  className="w-full px-4 py-2 border border-indigo-200 dark:border-indigo-700/50 rounded-lg focus:ring-2 focus:ring-indigo-500 bg-white dark:bg-slate-800 text-gray-900 dark:text-slate-100"
                >
                  <option value="" className="bg-white text-gray-900 dark:bg-slate-800 dark:text-gray-200">您自己 (默认所有者)</option>
                  {allUsers.map(u => (
                    <option key={u.id} value={u.id} className="bg-white text-gray-900 dark:bg-slate-800 dark:text-gray-200">{u.name} ( {u.role} )</option>
                  ))}
                </select>
                <p className="text-xs text-indigo-600/70 dark:text-indigo-400/70 mt-1">如果帮客户代劳配置，请在此选择客户账号。保存后，客户登录即可直接使用该配置。</p>
              </div>
            )}
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">主品牌名称</label>
                <input 
                  type="text" 
                  value={brand.name} 
                  onChange={(e) => setBrand({...brand, name: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  placeholder="例如: 特斯拉"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">子品牌名</label>
                <input 
                  type="text" 
                  value={brand.subBrandName || ''} 
                  onChange={(e) => setBrand({...brand, subBrandName: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  placeholder="例如: 07 (荣威07)"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">品牌别名/同义词 (支持逗号、顿号)</label>
                <input 
                  type="text" 
                  value={brand.aliases}
                  onChange={(e) => setBrand({...brand, aliases: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  placeholder="例如: Tesla, TSLA"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">品牌 Logo</label>
                <div className="flex space-x-2">
                  <div className="flex-1 flex space-x-2">
                    {brand.logo && (
                      <div className="w-10 h-10 rounded bg-white border border-gray-200 dark:border-slate-700 overflow-hidden flex items-center justify-center shrink-0">
                        <img src={brand.logo.startsWith('/') ? brand.logo : brand.logo} alt="Logo" className="max-w-full max-h-full object-contain" />
                      </div>
                    )}
                    <input 
                      type="text" 
                      value={brand.logo || ''}
                      onChange={(e) => setBrand({...brand, logo: e.target.value})}
                      className="flex-1 px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                      placeholder="URL 或点击右侧上传"
                    />
                    <label className="cursor-pointer bg-slate-700 hover:bg-slate-600 text-white px-4 py-2 rounded-lg text-sm flex items-center justify-center transition-colors shrink-0">
                      <span>上传</span>
                      <input type="file" className="hidden" accept="image/*" onChange={(e) => handleUploadImage(e, false)} />
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">官方网站 (可选)</label>
                <input 
                  type="text" 
                  value={brand.website}
                  onChange={(e) => setBrand({...brand, website: e.target.value})}
                  className="w-full px-4 py-2 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  placeholder="例如: tesla.cn"
                />
              </div>
            </div>

            {colleagues.length > 0 && (
              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">
                  协作者 <span className="text-xs text-gray-400 font-normal ml-1">(允许同组的其他同事查看并管理该项目的数据)</span>
                </label>
                <div className="flex flex-wrap gap-2 p-3 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg max-h-32 overflow-y-auto">
                  {colleagues.map(user => (
                    <label key={user.id} className="inline-flex items-center space-x-2 mr-4 mb-2 cursor-pointer">
                      <input 
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 text-gray-900 dark:text-slate-200"
                        checked={collaborators.includes(user.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setCollaborators([...collaborators, user.id]);
                          } else {
                            setCollaborators(collaborators.filter(id => id !== user.id));
                          }
                        }}
                      />
                      <span className="text-sm text-gray-700 dark:text-slate-300">{user.name}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            
            {/* 官方社媒账号配置 */}
            <div className="mt-4 pt-4 border-t border-gray-100 dark:border-slate-700/50">
              <div 
                className="flex items-center cursor-pointer select-none"
                onClick={() => setShowSocialMedia(!showSocialMedia)}
              >
                {showSocialMedia ? <ChevronDown className="w-4 h-4 text-gray-500 mr-2" /> : <ChevronRight className="w-4 h-4 text-gray-500 mr-2" />}
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 cursor-pointer">
                  官方社交账号/标识 <span className="text-xs text-gray-400 font-normal ml-1">(用于系统自动识别并过滤官方发声，确保大盘反映真实用户舆情)</span>
                </label>
              </div>
              
              {showSocialMedia && (
                <div className="grid grid-cols-2 gap-3 mt-3">
                  <div className="flex items-center bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500">
                    <div className="px-3 py-2 bg-gray-100 dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex items-center justify-center w-20">
                      <span className="text-xs font-medium text-gray-600 dark:text-slate-300">微博</span>
                    </div>
                    <input 
                      type="text" 
                      value={brand.socialMedia?.weibo || ''}
                      onChange={(e) => setBrand({...brand, socialMedia: {...brand.socialMedia, weibo: e.target.value}})}
                      className="flex-1 px-3 py-2 bg-transparent text-sm text-gray-900 dark:text-slate-200 outline-none"
                      placeholder="UID或精确主页名"
                    />
                  </div>
                  
                  <div className="flex items-center bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500">
                    <div className="px-3 py-2 bg-gray-100 dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex items-center justify-center w-20">
                      <span className="text-xs font-medium text-gray-600 dark:text-slate-300">抖音</span>
                    </div>
                    <input 
                      type="text" 
                      value={brand.socialMedia?.douyin || ''}
                      onChange={(e) => setBrand({...brand, socialMedia: {...brand.socialMedia, douyin: e.target.value}})}
                      className="flex-1 px-3 py-2 bg-transparent text-sm text-gray-900 dark:text-slate-200 outline-none"
                      placeholder="抖音号"
                    />
                  </div>

                  <div className="flex items-center bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500">
                    <div className="px-3 py-2 bg-gray-100 dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex items-center justify-center w-20">
                      <span className="text-xs font-medium text-gray-600 dark:text-slate-300">小红书</span>
                    </div>
                    <input 
                      type="text" 
                      value={brand.socialMedia?.xhs || ''}
                      onChange={(e) => setBrand({...brand, socialMedia: {...brand.socialMedia, xhs: e.target.value}})}
                      className="flex-1 px-3 py-2 bg-transparent text-sm text-gray-900 dark:text-slate-200 outline-none"
                      placeholder="小红书号"
                    />
                  </div>

                  <div className="flex items-center bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500">
                    <div className="px-3 py-2 bg-gray-100 dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700 flex items-center justify-center w-20">
                      <span className="text-xs font-medium text-gray-600 dark:text-slate-300">公众号</span>
                    </div>
                    <input 
                      type="text" 
                      value={brand.socialMedia?.wechat || ''}
                      onChange={(e) => setBrand({...brand, socialMedia: {...brand.socialMedia, wechat: e.target.value}})}
                      className="flex-1 px-3 py-2 bg-transparent text-sm text-gray-900 dark:text-slate-200 outline-none"
                      placeholder="微信号"
                    />
                  </div>
                </div>
              )}
            </div>

            
          </div>
        </div>

        {/* Right Column: Competitor Config */}
        <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50">
          <div className="flex justify-between items-center mb-4 border-b border-gray-100 dark:border-slate-700 pb-2">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">竞品设置</h2>
            <button onClick={addCompetitor} className="text-sm flex items-center text-indigo-600 dark:text-indigo-400 hover:text-indigo-700">
              <Plus size={16} className="mr-1" /> 添加竞品
            </button>
          </div>
          
          <div className="space-y-4 max-h-[520px] overflow-y-auto pr-2 custom-scrollbar">
            {competitors.map((comp, index) => (
              <div key={comp.id} className="flex space-x-3 items-start p-3 bg-gray-50 dark:bg-slate-900/30 rounded-lg border border-gray-100 dark:border-slate-700/50 relative group">
                <div className="flex-1 space-y-3">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">竞品 {index + 1} 名称</label>
                      <input 
                        type="text" 
                        value={comp.name}
                        onChange={(e) => updateCompetitor(comp.id, 'name', e.target.value)}
                        className="w-full px-3 py-1.5 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">别名/同义词 (支持逗号、顿号)</label>
                      <input 
                        type="text" 
                        value={comp.aliases}
                        onChange={(e) => updateCompetitor(comp.id, 'aliases', e.target.value)}
                        className="w-full px-3 py-1.5 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-3 mt-3">
                    <div>
                      <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">竞品 Logo</label>
                      <div className="flex space-x-2">
                        {comp.logo && (
                          <div className="w-8 h-8 rounded bg-white border border-gray-200 dark:border-slate-700 overflow-hidden flex items-center justify-center shrink-0">
                            <img src={comp.logo.startsWith('/') ? comp.logo : comp.logo} alt="Logo" className="max-w-full max-h-full object-contain" />
                          </div>
                        )}
                        <input 
                          type="text" 
                          value={comp.logo || ''}
                          onChange={(e) => updateCompetitor(comp.id, 'logo', e.target.value)}
                          className="flex-1 px-3 py-1.5 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                          placeholder="图片 URL 或上传"
                        />
                        <label className="cursor-pointer bg-slate-700 hover:bg-slate-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center justify-center transition-colors shrink-0">
                          <span>上传</span>
                          <input type="file" className="hidden" accept="image/*" onChange={(e) => handleUploadImage(e, true, comp.id)} />
                        </label>
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-500 dark:text-slate-400 mb-1">官方网站 (可选)</label>
                      <input 
                        type="text" 
                        value={comp.website || ''}
                        onChange={(e) => updateCompetitor(comp.id, 'website', e.target.value)}
                        className="w-full px-3 py-1.5 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                        placeholder="例如: byd.com"
                      />
                    </div>
                  </div>
                </div>
                <button onClick={() => removeCompetitor(comp.id)} className="p-1.5 text-gray-400 hover:text-red-500 rounded-md hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors mt-6">
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
            {competitors.length === 0 && (
              <p className="text-sm text-gray-500 dark:text-slate-400 text-center py-4">暂无竞品，点击右上角添加。</p>
            )}
          </div>
        </div>
      </div>
      )}

            {/* Full Width: Product Matrix (Optional Advanced Setup) */}


      {activeTab === 'matrix' && (
      <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 overflow-hidden mb-6 animate-in fade-in duration-200">
        <div className="p-6 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20 flex justify-between items-center">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">产品对标矩阵</h2>
            <p className="text-xs text-gray-500 dark:text-slate-400 mt-1">设置本品与竞品的精确映射，让 AI 对比分析时有的放矢（如 Model 3 vs 汉）。</p>
          </div>
          <div className="flex bg-gray-100 dark:bg-slate-800 p-1 rounded-lg">
            <button 
              onClick={() => setProductMappingMode('simple')}
              className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${productMappingMode === 'simple' ? 'bg-white dark:bg-slate-700 text-indigo-600 dark:text-indigo-400 shadow-sm' : 'text-gray-500 dark:text-slate-400 hover:text-gray-900 dark:hover:text-slate-200'}`}
            >
              无映射 (逗号隔离)
            </button>
            <button 
              onClick={() => setProductMappingMode('matrix')}
              className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${productMappingMode === 'matrix' ? 'bg-white dark:bg-slate-700 text-indigo-600 dark:text-indigo-400 shadow-sm' : 'text-gray-500 dark:text-slate-400 hover:text-gray-900 dark:hover:text-slate-200'}`}
            >
              启用精确对标矩阵
            </button>
          </div>
        </div>

        {productMappingMode === 'simple' && (
          <div className="p-6">
            <div className="space-y-6">
              <div className="bg-gray-50 dark:bg-slate-900/30 p-4 rounded-xl border border-gray-100 dark:border-slate-700/50">
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">本品产品 (请通过回车换行隔离)</label>
                <textarea 
                  value={brand.products || ''}
                  onChange={(e) => setBrand({...brand, products: e.target.value})}
                  className="w-full px-4 py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none resize-y min-h-[100px]"
                  placeholder="例如: Model 3, Model Y, Model S, Model X"
                />
              </div>
              
              {competitors.map((comp, index) => (
                <div key={comp.id} className="bg-gray-50 dark:bg-slate-900/30 p-4 rounded-xl border border-gray-100 dark:border-slate-700/50">
                  <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">{comp.name || `竞品 ${index + 1}`} 产品 (请通过回车换行隔离)</label>
                  <textarea 
                    value={comp.products || ''}
                    onChange={(e) => updateCompetitor(comp.id, 'products', e.target.value)}
                    className="w-full px-4 py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none resize-y min-h-[100px]"
                    placeholder="例如: 汉EV, 海豹, 唐DM-i"
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {productMappingMode === 'matrix' && (
          <div className="p-6">
            <div className="overflow-x-auto custom-scrollbar pb-4 -mx-6 px-6">
              <div className="space-y-4 min-w-max">
                <div className="flex gap-4 px-4 py-2 text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider mb-2 min-w-max">
                  <div className="w-56 shrink-0">本品: {brand.name || '未命名主品牌'}</div>
                  {competitors.map(c => (
                    <div key={c.id} className="w-56 shrink-0">竞品: {c.name || '未命名'}</div>
                  ))}
                  <div className="w-20 shrink-0 text-center">操作</div>
                </div>
                
                {productMappings.map(mapping => (
                  <div key={mapping.id} className="flex gap-4 p-4 bg-gray-50/50 dark:bg-slate-800/30 rounded-2xl hover:shadow-md hover:bg-white dark:hover:bg-slate-800 transition-all border border-transparent hover:border-indigo-100 dark:hover:border-indigo-500/30 group min-w-max">
                    {/* Host Product */}
                    <div className="w-56 shrink-0 space-y-2">
                      <div className="relative">
                        <input 
                          type="text" 
                          value={mapping.hostProduct}
                          onChange={e => updateProductMapping(mapping.id, 'hostProduct', e.target.value)}
                          placeholder="本品型号"
                          className="w-full px-4 py-2.5 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:focus:ring-indigo-500/20 rounded-xl text-sm font-medium transition-all outline-none dark:text-slate-200 shadow-sm"
                        />
                      </div>
                      {mapping.isAliasExpanded && (
                        <input
                          type="text"
                          value={mapping.hostAliases || ''}
                          onChange={e => updateProductMapping(mapping.id, 'hostAliases', e.target.value)}
                          placeholder="别名 (逗号分隔)"
                          className="w-full px-4 py-2 bg-white/50 dark:bg-slate-900/50 border border-gray-200/50 dark:border-slate-700/50 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/10 rounded-lg text-xs transition-all outline-none text-gray-600 dark:text-slate-400"
                        />
                      )}
                    </div>
                    
                    {/* Competitor Products */}
                    {competitors.map(c => {
                      const compProd = mapping.competitorProducts.find(cp => cp.compId === c.id);
                      return (
                        <div key={c.id} className="w-56 shrink-0 space-y-2">
                          <input 
                            type="text" 
                            value={compProd ? compProd.prodName : ''}
                            onChange={e => updateProductMapping(mapping.id, 'prodName', e.target.value, c.id)}
                            placeholder="无"
                            className="w-full px-4 py-2.5 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/10 dark:focus:ring-indigo-500/20 rounded-xl text-sm font-medium transition-all outline-none dark:text-slate-200 shadow-sm placeholder:text-gray-300 dark:placeholder:text-slate-600"
                          />
                          {mapping.isAliasExpanded && (
                            <input
                              type="text"
                              value={compProd ? compProd.prodAliases : ''}
                              onChange={e => updateProductMapping(mapping.id, 'prodAliases', e.target.value, c.id)}
                              placeholder="别名 (逗号分隔)"
                              className="w-full px-4 py-2 bg-white/50 dark:bg-slate-900/50 border border-gray-200/50 dark:border-slate-700/50 focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/10 rounded-lg text-xs transition-all outline-none text-gray-600 dark:text-slate-400"
                            />
                          )}
                        </div>
                      );
                    })}
                    
                    {/* Actions */}
                    <div className="w-20 shrink-0 flex items-start justify-center gap-1 pt-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button onClick={() => updateProductMapping(mapping.id, 'isAliasExpanded', !mapping.isAliasExpanded)} className={`p-2.5 rounded-xl transition-all ${mapping.isAliasExpanded ? 'text-indigo-600 bg-indigo-50 dark:bg-indigo-500/20 shadow-sm' : 'text-gray-400 hover:text-indigo-600 hover:bg-white dark:hover:bg-slate-700 hover:shadow-sm'}`}>
                        <Tags size={16} />
                      </button>
                      <button onClick={() => removeProductMapping(mapping.id)} className="p-2.5 text-gray-400 hover:text-red-500 hover:bg-white dark:hover:bg-slate-700 hover:shadow-sm rounded-xl transition-all">
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-4">
              <button onClick={addProductMapping} className="flex items-center space-x-2 text-sm text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 bg-indigo-50 dark:bg-indigo-900/20 px-4 py-2 rounded-lg transition-colors border border-indigo-100 dark:border-indigo-800/50">
                <Plus size={16} />
                <span>添加产品行</span>
              </button>
            </div>
          </div>
        )}
      </div>

      )}

      {activeTab === 'themes' && (
      <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 mb-8 overflow-hidden animate-in fade-in duration-200">
        <div className="p-6 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">核心业务维度 (宏观+微观 双层架构)</h2>
          <p className="text-xs text-gray-500 dark:text-slate-400 mt-1">设置宏观一级指标（建议不超过6个，用于雷达图），并在其下挂载微观细分维度（用于热力图）。</p>
        </div>
        <div className="p-6 space-y-6">
          {(brand.themes || []).map((theme, tIdx) => (
            <div key={theme.id || tIdx} className="border border-gray-200 dark:border-slate-700/60 rounded-xl overflow-hidden">
              {/* Level 1 Header */}
              <div className="flex items-center justify-between bg-slate-50 dark:bg-slate-800/80 p-4 border-b border-gray-200 dark:border-slate-700/60">
                <div className="flex items-center gap-3 flex-1">
                  <div className="w-8 h-8 rounded-lg bg-indigo-100 dark:bg-indigo-500/20 flex items-center justify-center text-indigo-600 dark:text-indigo-400 font-bold text-sm">
                    {tIdx + 1}
                  </div>
                  <input 
                    type="text"
                    value={theme.name}
                    onChange={(e) => {
                      const newThemes = [...(brand.themes || [])];
                      newThemes[tIdx].name = e.target.value;
                      setBrand({...brand, themes: newThemes});
                    }}
                    placeholder="一级宏观指标（如：舒适静音）"
                    className="flex-1 max-w-sm px-3 py-1.5 bg-white dark:bg-slate-900 border border-gray-300 dark:border-slate-600 rounded-md text-sm font-medium focus:border-indigo-500 outline-none dark:text-white text-gray-900 dark:text-slate-200"
                  />
                </div>
                <button 
                  onClick={() => {
                    const newThemes = [...(brand.themes || [])];
                    newThemes.splice(tIdx, 1);
                    setBrand({...brand, themes: newThemes});
                  }}
                  className="p-1.5 text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 rounded transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              
              {/* Level 2 Sub-themes */}
              <div className="p-4 bg-white dark:bg-slate-900/30">
                <div className="grid grid-cols-12 gap-4 mb-2 px-2 text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  <div className="col-span-4">二级细分指标 (微观卖点)</div>
                  <div className="col-span-7">包含的特征词/同义词</div>
                  <div className="col-span-1 text-center">操作</div>
                </div>
                
                <div className="space-y-2">
                  {(theme.subThemes || []).map((sub, sIdx) => (
                    <div key={sub.id || sIdx} className="grid grid-cols-12 gap-4 items-start bg-gray-50 dark:bg-slate-800/50 p-2.5 rounded-lg border border-gray-100 dark:border-slate-700/50">
                      <div className="col-span-4">
                        <input 
                          type="text" 
                          value={sub.name}
                          onChange={(e) => {
                            const newThemes = [...(brand.themes || [])];
                            newThemes[tIdx].subThemes[sIdx].name = e.target.value;
                            setBrand({...brand, themes: newThemes});
                          }}
                          placeholder="如: 胎噪抑制表现"
                          className="w-full px-3 py-1.5 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-md text-sm focus:border-indigo-500 dark:text-slate-200 outline-none"
                        />
                      </div>
                      <div className="col-span-7 relative flex items-center gap-2">
                        <input 
                          type="text" 
                          value={sub.keywords}
                          onChange={(e) => {
                            const newThemes = [...(brand.themes || [])];
                            newThemes[tIdx].subThemes[sIdx].keywords = e.target.value;
                            setBrand({...brand, themes: newThemes});
                          }}
                          placeholder="如: 胎噪, 静音好, 没声音"
                          className="w-full px-3 py-1.5 pr-8 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-600 rounded-md text-sm focus:border-indigo-500 dark:text-slate-200 outline-none"
                        />
                        <button
                          title="AI 拓词"
                          onClick={() => handleGenerateSynonyms(tIdx, sIdx, theme.name, sub.name)}
                          disabled={expandingSynonyms[`${tIdx}-${sIdx}`]}
                          className={`absolute right-2 text-indigo-500 hover:text-indigo-600 transition-colors ${expandingSynonyms[`${tIdx}-${sIdx}`] ? 'opacity-50 cursor-not-allowed' : ''}`}
                        >
                          {expandingSynonyms[`${tIdx}-${sIdx}`] ? <Loader2 size={16} className="animate-spin" /> : <Sparkles size={16} />}
                        </button>
                      </div>
                      <div className="col-span-1 flex justify-center mt-1">
                        <button 
                          onClick={() => {
                            const newThemes = [...(brand.themes || [])];
                            newThemes[tIdx].subThemes.splice(sIdx, 1);
                            setBrand({...brand, themes: newThemes});
                          }}
                          className="p-1 text-slate-400 hover:text-red-500 transition-colors"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  ))}
                  
                  <button 
                    onClick={() => {
                      const newThemes = [...(brand.themes || [])];
                      if (!newThemes[tIdx].subThemes) newThemes[tIdx].subThemes = [];
                      newThemes[tIdx].subThemes.push({ id: Date.now(), name: '', keywords: '' });
                      setBrand({...brand, themes: newThemes});
                    }}
                    className="mt-2 flex items-center px-3 py-1.5 text-xs font-medium text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 rounded-md transition-colors"
                  >
                    <Plus className="w-3.5 h-3.5 mr-1" /> 添加二级细分指标
                  </button>
                </div>
              </div>
            </div>
          ))}
          
          <button 
            onClick={() => {
              const newThemes = [...(brand.themes || [])];
              newThemes.push({ id: Date.now(), name: '', subThemes: [{ id: Date.now()+1, name: '', keywords: '' }] });
              setBrand({...brand, themes: newThemes});
            }}
            className="w-full py-3 border-2 border-dashed border-indigo-200 dark:border-indigo-500/30 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 rounded-xl flex items-center justify-center font-medium transition-colors"
          >
            <Plus className="w-5 h-5 mr-2" /> 新增一级宏观指标
          </button>
        </div>
      </div>
      )}
      
      {activeTab === 'researchSeeds' && (
      <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 mb-8 overflow-hidden animate-in fade-in duration-200">
        <div className="p-6 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">核心意图与种子词（场景化）</h2>
          <p className="text-xs text-gray-500 dark:text-slate-400 mt-1">设置用户向AI提问时常用的场景、痛点及对应种子词，为大模型生成真实Prompt提供弹药。</p>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-12 gap-4 mb-2 px-2 text-sm font-medium text-gray-500 dark:text-slate-400">
            <div className="col-span-3">场景/意图名称</div>
            <div className="col-span-8">核心种子词（逗号分隔）</div>
            <div className="col-span-1 text-center">操作</div>
          </div>
          <div className="space-y-3">
            {(brand.researchSeeds || []).map((rs, index) => (
              <div key={rs.id || index} className="grid grid-cols-12 gap-4 items-start bg-gray-50 dark:bg-slate-900/30 p-3 rounded-xl border border-gray-100 dark:border-slate-700/50">
                <div className="col-span-3">
                  <input 
                    type="text" 
                    value={rs.name}
                    onChange={(e) => {
                      const newSeeds = [...(brand.researchSeeds || [])];
                      newSeeds[index].name = e.target.value;
                      setBrand({...brand, researchSeeds: newSeeds});
                    }}
                    placeholder="如: 熬夜急救"
                    className="w-full px-3 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  />
                </div>
                <div className="col-span-8">
                  <input 
                    type="text"
                    value={rs.keywords}
                    onChange={(e) => {
                      const newSeeds = [...(brand.researchSeeds || [])];
                      newSeeds[index].keywords = e.target.value;
                      setBrand({...brand, researchSeeds: newSeeds});
                    }}
                    placeholder="如: 熬夜垮脸, 提亮肤色, 修复敏感"
                    className="w-full px-3 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  />
                </div>
                <div className="col-span-1 flex justify-center mt-2">
                  <button 
                    onClick={() => {
                      const newSeeds = (brand.researchSeeds || []).filter((_, i) => i !== index);
                      setBrand({...brand, researchSeeds: newSeeds});
                    }}
                    className="p-1.5 text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-lg transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
          <button 
            onClick={() => setBrand({...brand, researchSeeds: [...(brand.researchSeeds||[]), {id: Date.now(), name: '', keywords: ''}]})}
            className="mt-4 px-4 py-2 border border-dashed border-gray-300 dark:border-slate-600 text-gray-600 dark:text-slate-300 hover:text-indigo-600 hover:border-indigo-500 rounded-lg flex items-center justify-center font-medium transition-colors w-full"
          >
            <Plus className="w-4 h-4 mr-2" /> 添加新场景/意图
          </button>
        </div>
      </div>
      )}

      {activeTab === 'personas' && (
      <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 mb-8 overflow-hidden animate-in fade-in duration-200">
        <div className="p-6 border-b border-gray-100 dark:border-slate-700/50 bg-gray-50/50 dark:bg-slate-900/20">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-slate-100">受众人设库 (Persona Library)</h2>
          <p className="text-xs text-gray-500 dark:text-slate-400 mt-1">建立专属本项目的目标用户群体人设。系统全局已有 8 个通用人群（新锐白领、精致宝妈等），在此仅需添加本项目专属的特殊人群即可。</p>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-12 gap-4 mb-2 px-2 text-sm font-medium text-gray-500 dark:text-slate-400">
            <div className="col-span-3">人设标签</div>
            <div className="col-span-8">Prompt 背景设定 (发给大模型的前置提示词)</div>
            <div className="col-span-1 text-center">操作</div>
          </div>
          <div className="space-y-3">
            {(brand.personas || []).map((persona, index) => (
              <div key={persona.id} className="grid grid-cols-12 gap-4 items-start bg-gray-50 dark:bg-slate-900/30 p-3 rounded-xl border border-gray-100 dark:border-slate-700/50">
                <div className="col-span-3">
                  <input 
                    type="text" 
                    value={persona.name}
                    onChange={(e) => {
                      const newPersonas = [...(brand.personas || [])];
                      newPersonas[index].name = e.target.value;
                      setBrand({...brand, personas: newPersonas});
                    }}
                    placeholder="如: 都市女白领"
                    className="w-full px-3 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none"
                  />
                </div>
                <div className="col-span-8">
                  <textarea 
                    value={persona.prompt}
                    onChange={(e) => {
                      const newPersonas = [...(brand.personas || [])];
                      newPersonas[index].prompt = e.target.value;
                      setBrand({...brand, personas: newPersonas});
                    }}
                    placeholder="如: 我对机械参数完全不懂，只想要一台好开、好看、停车方便、内饰精致的纯电车。"
                    className="w-full px-3 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 dark:text-slate-200 outline-none min-h-[60px]"
                  />
                </div>
                <div className="col-span-1 flex justify-center mt-3">
                  <button 
                    onClick={() => {
                      const newPersonas = (brand.personas || []).filter(p => p.id !== persona.id);
                      setBrand({...brand, personas: newPersonas});
                    }}
                    className="p-1.5 text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10 rounded-lg transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
          <button 
            onClick={() => setBrand({...brand, personas: [...(brand.personas||[]), {id: Date.now(), name: '', prompt: ''}]})}
            className="mt-4 flex items-center px-4 py-2 text-sm text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-500/10 hover:bg-indigo-100 dark:hover:bg-indigo-500/20 rounded-lg transition-colors"
          >
            <Plus className="w-4 h-4 mr-1.5" /> 新增人设标签
          </button>
        </div>
      </div>

      )}

      {activeTab === 'keywords' && (
        <div className="bg-white dark:bg-slate-800/80 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700 overflow-hidden min-h-[500px] animate-in fade-in duration-200">
          <div className="p-6">
            <h3 className="font-bold text-gray-900 dark:text-white mb-2">监控词库配置</h3>
            <p className="text-sm text-gray-500 dark:text-slate-400 mb-6">AI 将基于您在此处建立的词包结构进行抓取，左侧为核心词维度（词包），右侧为具体搜索指令及标签属性。</p>
            
            <div className="flex min-h-[500px] h-[calc(100vh-280px)] border border-gray-200 dark:border-slate-700 rounded-xl overflow-hidden">
               {/* Left sidebar: Packages */}
               <div className="w-64 bg-gray-50 dark:bg-slate-900/50 border-r border-gray-200 dark:border-slate-700 flex flex-col">
                  <div className="p-3 border-b border-gray-200 dark:border-slate-700 flex justify-between items-center">
                    <span className="font-semibold text-sm text-gray-700 dark:text-slate-300">核心词 (词包)</span>
                    <button onClick={addKeywordPackage} className="p-1 hover:bg-gray-200 dark:hover:bg-slate-800 rounded">
                      <Plus size={14} className="text-indigo-600 dark:text-indigo-400" />
                    </button>
                  </div>
                  <div className="flex-1 overflow-y-auto custom-scrollbar">
                    <button 
                      onClick={() => setSelectedPkgId('all')} 
                      className={`w-full text-left px-4 py-3 text-sm transition-colors border-l-2 ${(!selectedPkgId || selectedPkgId === 'all') ? 'bg-white dark:bg-slate-800 border-indigo-600 font-bold text-indigo-700 dark:text-indigo-400' : 'border-transparent text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800/50'}`}
                    >
                      <div className="flex items-center justify-between w-full">
                        <span>全部关键词</span>
                        <span className="text-xs bg-gray-100 dark:bg-slate-700 text-gray-500 dark:text-slate-400 px-2 py-0.5 rounded-full">
                          {keywordPackages.reduce((sum, p) => sum + (p.items ? p.items.length : 0), 0)}
                        </span>
                      </div>
                    </button>
                    {/* Categorized Collapsible */}
                    <div className="border-b border-gray-100 dark:border-slate-800">
                      <button
                        onClick={() => setIsCategorizedExpanded(!isCategorizedExpanded)}
                        className="w-full text-left px-4 py-2 text-xs font-semibold text-gray-500 dark:text-slate-400 bg-gray-50 dark:bg-slate-900/50 hover:bg-gray-100 dark:hover:bg-slate-800/80 flex items-center transition-colors"
                      >
                        {isCategorizedExpanded ? <ChevronDown size={14} className="mr-1" /> : <ChevronRight size={14} className="mr-1" />}
                        已分类 ({keywordPackages.filter(p => p.name !== '未分类').length})
                      </button>
                      
                      {isCategorizedExpanded && keywordPackages.filter(p => p.name !== '未分类').map(pkg => (
                        <button 
                          key={pkg.id}
                          onClick={() => setSelectedPkgId(pkg.id)} 
                          className={`w-full text-left pl-8 pr-4 py-2.5 text-sm transition-colors border-l-2 flex justify-between items-center group ${selectedPkgId === pkg.id ? 'bg-white dark:bg-slate-800 border-indigo-600 font-bold text-indigo-700 dark:text-indigo-400' : 'border-transparent text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800/50'}`}
                        >
                          {isAddingPkg === pkg.id ? (
                             <input 
                                autoFocus
                                type="text" 
                                defaultValue={pkg.name}
                                onBlur={(e) => { setIsAddingPkg(false); if(e.target.value !== pkg.name) updatePackageName(pkg.id, e.target.value); }}
                                onKeyDown={(e) => { if(e.key === 'Enter') { setIsAddingPkg(false); if(e.target.value !== pkg.name) updatePackageName(pkg.id, e.target.value); } }}
                                className="w-full bg-white dark:bg-slate-700 border border-indigo-500 outline-none px-1 rounded text-gray-900 dark:text-slate-100"
                             />
                          ) : (
                             <div className="flex items-center justify-between flex-1 min-w-0 pr-2" onDoubleClick={() => setIsAddingPkg(pkg.id)}>
                               <span className="truncate">{pkg.name}</span>
                               <span className="text-xs bg-gray-100 dark:bg-slate-700 text-gray-500 dark:text-slate-400 px-1.5 py-0.5 rounded-full ml-2 flex-shrink-0">{pkg.items ? pkg.items.length : 0}</span>
                             </div>
                          )}
                          <Trash2 size={12} onClick={(e) => { e.stopPropagation(); removeKeywordPackage(pkg.id); }} className="text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 flex-shrink-0" />
                        </button>
                      ))}
                    </div>

                    {/* Uncategorized Fixed */}
                    {keywordPackages.filter(p => p.name === '未分类').map(pkg => (
                        <button 
                          key={pkg.id}
                          onClick={() => setSelectedPkgId(pkg.id)} 
                          className={`w-full text-left px-4 py-3 text-sm transition-colors border-l-2 flex justify-between items-center group ${selectedPkgId === pkg.id ? 'bg-white dark:bg-slate-800 border-indigo-600 font-bold text-indigo-700 dark:text-indigo-400' : 'border-transparent text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800/50'}`}
                        >
                          {isAddingPkg === pkg.id ? (
                             <input 
                                autoFocus
                                type="text" 
                                defaultValue={pkg.name}
                                onBlur={(e) => { setIsAddingPkg(false); if(e.target.value !== pkg.name) updatePackageName(pkg.id, e.target.value); }}
                                onKeyDown={(e) => { if(e.key === 'Enter') { setIsAddingPkg(false); if(e.target.value !== pkg.name) updatePackageName(pkg.id, e.target.value); } }}
                                className="w-full bg-white dark:bg-slate-700 border border-indigo-500 outline-none px-1 rounded text-gray-900 dark:text-slate-100"
                             />
                          ) : (
                             <div className="flex items-center justify-between flex-1 min-w-0 pr-2" onDoubleClick={() => setIsAddingPkg(pkg.id)}>
                               <span className="truncate font-medium">{pkg.name}</span>
                               <span className="text-xs bg-gray-100 dark:bg-slate-700 text-gray-500 dark:text-slate-400 px-1.5 py-0.5 rounded-full ml-2 flex-shrink-0">{pkg.items ? pkg.items.length : 0}</span>
                             </div>
                          )}
                          <Trash2 size={12} onClick={(e) => { e.stopPropagation(); removeKeywordPackage(pkg.id); }} className="text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 flex-shrink-0" />
                        </button>
                    ))}
                  </div>
               </div>
               
               {/* Right side: Keywords Table */}
               <div className="flex-1 bg-white dark:bg-slate-800 flex flex-col min-w-0">
                 <div className="p-3 border-b border-gray-200 dark:border-slate-700 flex justify-between items-center bg-gray-50/50 dark:bg-slate-900/30 overflow-x-auto">
                   <div className="flex items-center space-x-2 shrink-0">
                      <button onClick={() => addPackageItem(selectedPkgId === 'all' || !selectedPkgId ? (keywordPackages[0]?.id) : selectedPkgId)} className="flex items-center px-3 py-1.5 bg-indigo-50 text-indigo-600 hover:bg-indigo-100 dark:bg-indigo-500/10 dark:text-indigo-400 dark:hover:bg-indigo-500/20 rounded-md text-sm transition-colors border border-indigo-100 dark:border-indigo-500/20">
                        <Plus size={14} className="mr-1" /> 添加关键词
                      </button>
                      <button onClick={() => setIsAdvancedEntryOpen(true)} className="flex items-center px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700 rounded-md text-sm border border-gray-200 dark:border-slate-600 transition-colors">
                        <ListPlus size={14} className="mr-1" /> 高级录入
                      </button>
                      <button onClick={() => setAiExpandState({ isOpen: true })} className="flex items-center px-3 py-1.5 bg-gradient-to-r from-purple-500 to-indigo-500 text-white hover:from-purple-600 hover:to-indigo-600 rounded-md text-sm shadow-sm transition-all">
                        <Sparkles size={14} className="mr-1" /> AI 智能拓词
                      </button>
                   </div>
                   <div className="flex items-center space-x-2 shrink-0 ml-4">
                      <button onClick={handleAiTagging} className="flex items-center px-3 py-1.5 bg-gradient-to-r from-purple-500 to-indigo-500 text-white hover:from-purple-600 hover:to-indigo-600 rounded-md text-sm shadow-sm transition-all">
                        {isAiTaggingLoading ? <Loader2 size={14} className="mr-1 animate-spin" /> : <Tags size={14} className="mr-1" />}
                        一键批量打标
                      </button>
                      <button onClick={() => { if(selectedItemIds.size === 0) { alert('请先勾选要批量处理的关键词'); return; } setIsBatchEditOpen(true); }} className="flex items-center px-3 py-1.5 bg-white text-gray-700 hover:bg-gray-50 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700 rounded-md text-sm border border-gray-200 dark:border-slate-600 transition-colors">
                        <Edit2 size={14} className="mr-1" /> 批量修改属性
                      </button>
                   </div>
                 </div>

                 <div className="flex-1 overflow-auto custom-scrollbar bg-white dark:bg-slate-800 relative">
                   <table className="w-full text-left text-sm whitespace-nowrap">
                     <thead className="bg-gray-50 dark:bg-slate-900/50 sticky top-0 z-10 shadow-sm">
                       <tr>
                         <th className="px-4 py-3 w-10 text-center">
                           <input 
                             type="checkbox" 
                             className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                             onChange={(e) => {
                               if (e.target.checked) {
                                 const allIds = [];
                                 keywordPackages.forEach(pkg => {
                                   if (selectedPkgId === 'all' || pkg.id === selectedPkgId) {
                                     (pkg.items || []).forEach(i => allIds.push(i.id));
                                   }
                                 });
                                 setSelectedItemIds(new Set(allIds));
                               } else {
                                 setSelectedItemIds(new Set());
                               }
                             }}
                           />
                         </th>
                         <th className="px-4 py-3 font-medium text-gray-500 dark:text-slate-400 min-w-[200px]">抓取搜索词 (指令)</th>
   <th className="px-4 py-3 font-medium text-gray-500 dark:text-slate-400 w-28">词性 (Category)</th>
   <th className="px-4 py-3 font-medium text-gray-500 dark:text-slate-400 w-24">搜索热度</th>
   <th className="px-4 py-3 font-medium text-gray-500 dark:text-slate-400 w-36">4A 阶段</th>
   <th className="px-4 py-3 font-medium text-gray-500 dark:text-slate-400 w-40">宏观业务维度</th>
   <th className="px-4 py-3 font-medium text-gray-500 dark:text-slate-400 w-40">微观业务维度</th>
                         <th className="px-4 py-3 font-medium text-gray-500 dark:text-slate-400 w-16 text-center">操作</th>
                       </tr>
                     </thead>
                     <tbody className="divide-y divide-gray-100 dark:divide-slate-700/50">
                       {keywordPackages.filter(p => selectedPkgId === 'all' || !selectedPkgId || p.id === selectedPkgId).map(pkg => (
                         (pkg.items || []).map(item => (
                           <tr key={`${pkg.id}-${item.id}`} className="group hover:bg-indigo-50/30 dark:hover:bg-slate-700/30 transition-colors">
                             <td className="px-4 py-4 text-center">
                               <input 
                                 type="checkbox" 
                                 className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                                 checked={selectedItemIds.has(item.id)}
                                 onChange={(e) => {
                                   const newSet = new Set(selectedItemIds);
                                   if (e.target.checked) newSet.add(item.id);
                                   else newSet.delete(item.id);
                                   setSelectedItemIds(newSet);
                                 }}
                               />
                             </td>
                             <td className="px-4 py-4 max-w-[240px]">
                               <input 
                                 type="text"
                                 title={item.expansions || ''}
                                 value={item.expansions || ''}
                                 onChange={(e) => updatePackageItem(pkg.id, item.id, 'expansions', e.target.value)}
                                 onBlur={(e) => {
                                   const val = e.target.value.trim();
                                   if (!val) return;
                                   let count = 0;
                                   keywordPackages.forEach(p => {
                                     (p.items || []).forEach(it => {
                                       if (it.expansions?.trim() === val && it.id !== item.id) count++;
                                     });
                                   });
                                   if (count > 0) {
                                     alert(`关键词 "${val}" 已经存在，不可重复添加！`);
                                     updatePackageItem(pkg.id, item.id, 'expansions', '');
                                   }
                                 }}
                                 className="w-full bg-transparent border-0 focus:ring-0 p-0 text-sm text-gray-900 dark:text-slate-200 text-ellipsis overflow-hidden whitespace-nowrap"
                                 placeholder="输入搜索词..."
                               />
                             </td>
                             <td className="px-4 py-4">
                               <select 
                                 value={item.category || ''}
                                 onChange={(e) => updatePackageItem(pkg.id, item.id, 'category', e.target.value)}
                                 className="w-full bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 px-2 py-1.5 focus:ring-1 focus:ring-indigo-500 text-xs text-gray-700 dark:text-slate-200 cursor-pointer rounded-md outline-none"
                               >
                                 <option value="" className="bg-white dark:bg-slate-800">--无--</option>
                                 <option value="Brand">Brand (品牌词)</option>
                                 <option value="Competitor">Competitor (竞品词)</option>
                                 <option value="Generic">Generic (通用词)</option>
                                 <option value="Compare">Compare (对比词)</option>
                               </select>
                             </td>
                             <td className="px-4 py-4">
                               <div 
                                 onClick={() => {
                                   const current = item.volume === 100 ? '高' : item.volume === 50 ? '中' : item.volume === 10 ? '低' : item.volume;
                                   const cycle = { '': '高', '高': '中', '中': '低', '低': '' };
                                   updatePackageItem(pkg.id, item.id, 'volume', cycle[current || '']);
                                 }}
                                 className={`cursor-pointer inline-flex items-center justify-center px-3 py-1 text-xs font-medium rounded-full transition-all ${
                                   (item.volume === '高' || item.volume === 100) ? 'bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-400 dark:border dark:border-red-500/30' :
                                   (item.volume === '中' || item.volume === 50) ? 'bg-orange-100 text-orange-700 dark:bg-orange-500/20 dark:text-orange-400 dark:border dark:border-orange-500/30' :
                                   (item.volume === '低' || item.volume === 10) ? 'bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-400 dark:border dark:border-green-500/30' :
                                   'border border-dashed border-gray-300 text-gray-400 dark:border-slate-600 dark:text-slate-500 hover:bg-gray-50 dark:hover:bg-slate-800'
                                 }`}
                               >
                                 {(item.volume === '高' || item.volume === 100) ? '高' : (item.volume === '中' || item.volume === 50) ? '中' : (item.volume === '低' || item.volume === 10) ? '低' : '--'}
                               </div>
                             </td>
                             <td className="px-4 py-4">
                               <select 
                                 value={item.stage || ''}
                                 onChange={(e) => updatePackageItem(pkg.id, item.id, 'stage', e.target.value)}
                                 className="w-full bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 px-2 py-1.5 focus:ring-1 focus:ring-indigo-500 text-xs text-gray-700 dark:text-slate-200 cursor-pointer rounded-md outline-none"
                               >
                                 <option value="" className="bg-white dark:bg-slate-800">--无--</option>
                                 <option value="Aware">Aware (认知)</option>
                                 <option value="Appeal">Appeal (吸引)</option>
                                 <option value="Ask">Ask (问询)</option>
                                 <option value="Act">Act (行动)</option>
                               </select>
                             </td>
                             <td className="px-4 py-4">
                               <select 
                                 value={item.macro || ''}
                                 onChange={(e) => {
                                   updatePackageItem(pkg.id, item.id, 'macro', e.target.value);
                                   // Auto-clear micro if macro changes to keep options valid
                                   updatePackageItem(pkg.id, item.id, 'micro', '');
                                 }}
                                 className="w-full bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 px-2 py-1.5 focus:ring-1 focus:ring-indigo-500 text-xs text-gray-700 dark:text-slate-200 cursor-pointer rounded-md outline-none"
                               >
                                 <option value="" className="bg-white dark:bg-slate-800">--无--</option>
                                 {(brand.themes || []).map((t, idx) => (
                                   <option key={t.id || idx} value={t.name}>{t.name}</option>
                                 ))}
                                 {item.macro && !(brand.themes || []).find(t => t.name === item.macro) && (
                                   <option value={item.macro}>{item.macro} (旧数据)</option>
                                 )}
                               </select>
                             </td>
                             <td className="px-4 py-4">
                               <select 
                                 value={item.micro || ''}
                                 onChange={(e) => updatePackageItem(pkg.id, item.id, 'micro', e.target.value)}
                                 className="w-full bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 px-2 py-1.5 focus:ring-1 focus:ring-indigo-500 text-xs text-gray-700 dark:text-slate-200 cursor-pointer rounded-md outline-none"
                               >
                                 <option value="" className="bg-white dark:bg-slate-800">--无--</option>
                                 {(() => {
                                   const macroTheme = (brand.themes || []).find(t => t.name === item.macro);
                                   const subs = macroTheme ? (macroTheme.subThemes || []) : [];
                                   return subs.map((sub, idx) => (
                                     <option key={sub.id || idx} value={sub.name}>{sub.name}</option>
                                   ));
                                 })()}
                                 {item.micro && (
                                   <option value={item.micro}>{item.micro} {((brand.themes || []).find(t => t.name === item.macro)?.subThemes || []).find(s => s.name === item.micro) ? '' : '(旧数据)'}</option>
                                 )}
                               </select>
                             </td>
                             <td className="px-4 py-4 text-center">
                               <button onClick={() => removePackageItem(pkg.id, item.id)} className="text-gray-300 hover:text-red-500 transition-colors opacity-0 group-hover:opacity-100 p-1">
                                 <Trash2 size={14} />
                               </button>
                             </td>
                           </tr>
                         ))
                       ))}
                     </tbody>
                   </table>
                 </div>
               </div>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'alerts' && (
        <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl p-8 rounded-2xl shadow-sm border border-red-100 dark:border-red-900/30 animate-in fade-in duration-200">
          <div className="mb-6 flex items-center gap-3">
            <div className="p-2 bg-red-100 dark:bg-red-500/20 text-red-600 dark:text-red-400 rounded-lg">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-slate-100">GEO Radar 预警设置</h2>
              <p className="text-sm text-gray-500 dark:text-slate-400 mt-1">设置风险监控指标。当大盘数据出现异常跌幅时，通过 Webhook 自动推送报警信息。</p>
            </div>
          </div>

          <div className="space-y-8 max-w-4xl">
            {/* Webhook Configuration */}
            <div className="bg-slate-50 dark:bg-slate-900/50 p-6 rounded-xl border border-slate-200 dark:border-slate-700/50">
              <h3 className="text-sm font-semibold text-gray-800 dark:text-slate-200 mb-4 flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 8c0 3.613-3.869 7.469-6 11-2.131-3.531-6-7.387-6-11a6 6 0 1 1 12 0z"/><circle cx="12" cy="8" r="2"/></svg>
                报警触达通道
              </h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">
                  Webhook URL (支持飞书、钉钉、企业微信机器人)
                </label>
                <input
                  type="text"
                  value={alertConfig.webhook}
                  onChange={e => setAlertConfig({...alertConfig, webhook: e.target.value})}
                  placeholder="https://open.feishu.cn/open-apis/bot/v2/hook/..."
                  className="w-full px-4 py-3 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm text-gray-900 dark:text-slate-100 placeholder-gray-400"
                />
              </div>
            </div>

            {/* Threshold Rules */}
            <div className="bg-slate-50 dark:bg-slate-900/50 p-6 rounded-xl border border-slate-200 dark:border-slate-700/50">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-sm font-semibold text-gray-800 dark:text-slate-200 flex items-center gap-2">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
                  触发规则阈值
                </h3>
                <button
                  onClick={() => setAlertConfig({...alertConfig, rules: [...alertConfig.rules, {metric: 'negative', threshold: 15}]})}
                  className="text-sm text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 font-medium flex items-center gap-1"
                >
                  <Plus size={14}/> 添加规则
                </button>
              </div>

              <div className="space-y-4">
                {alertConfig.rules.map((rule, idx) => (
                  <div key={idx} className="flex items-center gap-4 bg-white dark:bg-slate-800 p-4 rounded-lg border border-gray-100 dark:border-slate-700">
                    <select
                      value={rule.metric}
                      onChange={e => {
                        const newRules = [...alertConfig.rules];
                        newRules[idx].metric = e.target.value;
                        setAlertConfig({...alertConfig, rules: newRules});
                      }}
                      className="w-1/3 px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-100"
                    >
                      <option value="negative">🚨 负面评价占比激增 (大于)</option>
                      <option value="top1_drop">📉 Top 1 占位率跌破 (小于)</option>
                      <option value="sov_drop">⚠️ 品牌提及率 (SOV) 跌破 (小于)</option>
                    </select>
                    
                    <div className="flex items-center gap-2 flex-1">
                      <span className="text-sm text-gray-500 dark:text-slate-400">{rule.metric === 'negative' ? '≥' : '≤'}</span>
                      <input
                        type="number"
                        value={rule.threshold}
                        onChange={e => {
                          const newRules = [...alertConfig.rules];
                          newRules[idx].threshold = parseFloat(e.target.value);
                          setAlertConfig({...alertConfig, rules: newRules});
                        }}
                        className="w-24 px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-center text-gray-900 dark:text-slate-100"
                      />
                      <span className="text-sm text-gray-500 dark:text-slate-400">% 时触发报警</span>
                    </div>

                    <button
                      onClick={() => {
                        const newRules = alertConfig.rules.filter((_, i) => i !== idx);
                        setAlertConfig({...alertConfig, rules: newRules});
                      }}
                      className="text-gray-400 hover:text-red-500 transition-colors"
                    >
                      <Trash2 size={16}/>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    
      {activeTab === 'clientMedia' && (
        <div className="bg-white dark:bg-slate-800/50 dark:backdrop-blur-xl p-8 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700/50 animate-in fade-in duration-200 mb-8">
           <ClientMediaManager projectId={editingId} />
        </div>
      )}
  

      {/* Batch Edit Modal */}
      {isBatchEditOpen && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200">
          <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl w-full max-w-md border border-gray-100 dark:border-slate-700 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 dark:border-slate-700 flex justify-between items-center bg-gray-50/50 dark:bg-slate-900/20">
              <h3 className="font-semibold text-gray-900 dark:text-slate-100 flex items-center"><Tags size={18} className="mr-2 text-indigo-500" /> 批量打标/修改属性</h3>
              <button onClick={() => setIsBatchEditOpen(false)} className="text-gray-400 hover:text-gray-600 dark:hover:text-slate-300 transition-colors">&times;</button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-xs text-gray-500 dark:text-slate-400">将对当前已勾选的 <span className="font-bold text-indigo-600">{selectedItemIds.size}</span> 个关键词批量应用以下属性。留空的选项将不会覆盖原有数据。</p>
              
                            <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">所属词包</label>
                <select 
                  value={batchEditForm.packageId}
                  onChange={e => setBatchEditForm({...batchEditForm, packageId: e.target.value})}
                  className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-200"
                >
                   <option value="">-- 不修改 --</option>
                   {keywordPackages.map(pkg => (
                     <option key={pkg.id} value={pkg.id}>{pkg.name}</option>
                   ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">词性 (Category)</label>
                <select 
                  value={batchEditForm.category}
                  onChange={e => setBatchEditForm({...batchEditForm, category: e.target.value})}
                  className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-200"
                >
                   <option value="">-- 不修改 --</option>
                   <option value="Brand">Brand (品牌词)</option>
                   <option value="Competitor">Competitor (竞品词)</option>
                   <option value="Generic">Generic (通用词)</option>
                                 <option value="Compare">Compare (对比词)</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">4A 阶段</label>
                <select 
                  value={batchEditForm.stage}
                  onChange={e => setBatchEditForm({...batchEditForm, stage: e.target.value})}
                  className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-200"
                >
                   <option value="">-- 不修改 --</option>
                   <option value="Aware">Aware (认知)</option>
                   <option value="Appeal">Appeal (吸引)</option>
                   <option value="Ask">Ask (问询)</option>
                   <option value="Act">Act (行动)</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">宏观业务维度</label>
                <select 
                  value={batchEditForm.macro}
                  onChange={e => setBatchEditForm({...batchEditForm, macro: e.target.value, micro: ''})}
                  className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-200"
                >
                   <option value="">-- 不修改 --</option>
                   {(brand.themes || []).map((t, idx) => (
                     <option key={idx} value={t.name}>{t.name}</option>
                   ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1">微观业务维度</label>
                <select 
                  value={batchEditForm.micro}
                  onChange={e => setBatchEditForm({...batchEditForm, micro: e.target.value})}
                  className="w-full px-3 py-2 bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-200"
                >
                   <option value="">-- 不修改 --</option>
                   {(() => {
                     const macroTheme = (brand.themes || []).find(t => t.name === batchEditForm.macro);
                     const subs = macroTheme ? (macroTheme.subThemes || []) : [];
                     return subs.map((sub, idx) => (
                       <option key={idx} value={sub.name}>{sub.name}</option>
                     ));
                   })()}
                </select>
              </div>
            </div>
            <div className="px-6 py-4 bg-gray-50 dark:bg-slate-900/50 flex justify-end gap-3 border-t border-gray-100 dark:border-slate-700">
              <button onClick={() => setIsBatchEditOpen(false)} className="px-4 py-2 text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors">取消</button>
              <button 
                onClick={() => {
                  
                  const targetPackageId = batchEditForm.packageId;
                  const currentForm = { ...batchEditForm };
                  const selected = new Set(selectedItemIds);

                  setKeywordPackages(pkgs => {
                    let itemsToMove = [];
                    let newPkgs = pkgs.map(pkg => {
                      let newItems = [];
                      for (let item of pkg.items) {
                        if (selected.has(item.id)) {
                          let updatedItem = {
                            ...item,
                            stage: currentForm.stage || item.stage,
                            macro: currentForm.macro || item.macro,
                            micro: currentForm.micro || item.micro,
                            category: currentForm.category || item.category
                          };
                          if (targetPackageId && String(pkg.id) !== String(targetPackageId)) {
                            itemsToMove.push(updatedItem);
                          } else {
                            newItems.push(updatedItem);
                          }
                        } else {
                          newItems.push(item);
                        }
                      }
                      return { ...pkg, items: newItems };
                    });

                    if (targetPackageId && itemsToMove.length > 0) {
                      const targetPkgIndex = newPkgs.findIndex(p => String(p.id) === String(targetPackageId));
                      if (targetPkgIndex !== -1) {
                        newPkgs[targetPkgIndex].items.push(...itemsToMove);
                      }
                    }
                    
                    // We trigger auto-save manually via setTimeout so we don't rely on useEffect which might capture stale closures
                    setTimeout(() => {
                        const saveBtn = document.getElementById('hidden-save-btn');
                        if (saveBtn) { const evt = new MouseEvent('click', {bubbles: true}); evt.isAutoSaveEvent = true; saveBtn.dispatchEvent(evt); }
                    }, 300);

                    return newPkgs;
                  });

                  setIsBatchEditOpen(false);
                  setBatchEditForm({stage: '', macro: '', micro: '', packageId: '', category: ''});
                  setSelectedItemIds(new Set());

                }}
                className="px-4 py-2 text-sm bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors"
              >
                确认应用
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Advanced Entry Modal */}

      {/* AI Expand Modal */}
      <AiExpandModal 
        isOpen={aiExpandState.isOpen}
        onClose={() => setAiExpandState({ isOpen: false })}
        brandName={brand.name || '当前品牌'}
        themeName={(selectedPkgId && selectedPkgId !== 'all' ? keywordPackages.find(p => p.id === selectedPkgId)?.name : keywordPackages[0]?.name) || brand.name || '业务关键词'}
        onConfirm={(selectedWords) => {
          const existingWords = new Set();
          keywordPackages.forEach(p => (p.items||[]).forEach(i => {
            if (i.expansions) existingWords.add(i.expansions.trim());
          }));
          
          const newWordsRaw = selectedWords.map(w => w.word.trim()).filter(Boolean);
          const duplicates = newWordsRaw.filter(w => existingWords.has(w));
          if (duplicates.length > 0) {
            alert(`以下 AI 拓词已存在，将被过滤不入库：\n${duplicates.join(', ')}`);
          }
          
          const validWords = newWordsRaw.filter(w => !existingWords.has(w));
          const uniqueValidWords = [...new Set(validWords)];
          
          if (uniqueValidWords.length > 0) {
            const targetPkgId = selectedPkgId === 'all' || !selectedPkgId ? keywordPackages[0]?.id : selectedPkgId;
            if (!targetPkgId) {
              alert('没有可用的词包');
              return;
            }
            setKeywordPackages(pkgs => pkgs.map(pkg => {
              if (pkg.id === targetPkgId) {
                const newItems = uniqueValidWords.map(word => ({ id: Date.now() + Math.random(), expansions: word, core: '', stage: '', macro: '', micro: '', category: '', volume: '' }));
                return { ...pkg, items: [...(pkg.items || []), ...newItems] };
              }
              return pkg;
            }));
          }
          
          setAiExpandState({ isOpen: false });
        }}
      />

      {isAdvancedEntryOpen && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200">
          <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl w-full max-w-2xl border border-gray-100 dark:border-slate-700 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 dark:border-slate-700 flex justify-between items-center bg-gray-50/50 dark:bg-slate-900/20">
              <h3 className="font-semibold text-gray-900 dark:text-slate-100 flex items-center"><ListPlus size={18} className="mr-2 text-indigo-500" /> 高级录入</h3>
              <button onClick={() => setIsAdvancedEntryOpen(false)} className="text-gray-400 hover:text-gray-600 dark:hover:text-slate-300 transition-colors">&times;</button>
            </div>
            <div className="p-6">
              <p className="text-sm text-gray-500 dark:text-slate-400 mb-3">请每行输入一个完整的提问/提示词。这些词将追加到当前选中的词包中。</p>
              <textarea 
                value={advancedEntryText}
                onChange={e => setAdvancedEntryText(e.target.value)}
                className="w-full h-64 p-4 bg-gray-50 dark:bg-slate-900/50 border border-gray-200 dark:border-slate-700 rounded-lg text-sm text-gray-900 dark:text-slate-200 outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="例如:
关键词1
关键词2
关键词3"
              ></textarea>
              <div className="mt-2 text-xs text-gray-400">预计解析出 {advancedEntryText.split(/\r?\n/).filter(k => k.trim()).length} 个有效词组</div>
            </div>
            <div className="px-6 py-4 bg-gray-50 dark:bg-slate-900/50 flex justify-end gap-3 border-t border-gray-100 dark:border-slate-700">
              <button onClick={() => setIsAdvancedEntryOpen(false)} className="px-4 py-2 text-sm text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors">取消</button>
              <button 
                onClick={() => {
                  const targetPkgId = selectedPkgId === 'all' || !selectedPkgId ? keywordPackages[0]?.id : selectedPkgId;
                  if (!targetPkgId) return alert('没有可用的词包');
                  
                  const existingWords = new Set();
                  keywordPackages.forEach(p => (p.items||[]).forEach(i => {
                    if (i.expansions) existingWords.add(i.expansions.trim());
                  }));
                  const newWordsRaw = advancedEntryText.split(/\r?\n/).map(k => k.trim()).filter(Boolean);
                  const duplicates = newWordsRaw.filter(w => existingWords.has(w));
                  if (duplicates.length > 0) {
                    alert(`以下关键词已存在，将被过滤不入库：\n${duplicates.join(', ')}`);
                  }
                  const validWords = newWordsRaw.filter(w => !existingWords.has(w));
                  const uniqueValidWords = [...new Set(validWords)];
                  if (uniqueValidWords.length === 0) return;
                  
                  setKeywordPackages(pkgs => pkgs.map(pkg => {
                    if (pkg.id === targetPkgId) {
                      const newItems = uniqueValidWords.map(word => ({ id: Date.now() + Math.random(), expansions: word, core: '', stage: '', macro: '', micro: '', category: '', volume: '' }));
                      return { ...pkg, items: [...newItems, ...(pkg.items || [])] };
                    }
                    return pkg;
                  }));
                  
                  setIsAdvancedEntryOpen(false);
                  setAdvancedEntryText('');
                }}
                className="px-4 py-2 text-sm bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors"
              >
                确认录入
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
